import { transformAudioFragment } from './chunk-DEH3IUAL.mjs';
import { PlaylistFragment, PlaylistAudioFragment } from './chunk-IQYQ7RE4.mjs';
import { useRequest } from './chunk-SNCLEEAV.mjs';
import { useAuthContext } from './chunk-K3UDKV2P.mjs';
import { getFragmentData } from './chunk-KTM5ANUO.mjs';
import { graphql } from './chunk-NWN55YVG.mjs';
import { __spreadProps, __spreadValues } from './chunk-4U7ZT42S.mjs';

// src/listen/query-hooks/playlist-detail.ts
var playlistDetailQuery = graphql(
  /* GraphQL */
  `
  query ListenPlaylistDetail($id: uuid!) {
    playlist_by_pk(id: $id) {
      ...ListenPlaylistFields
    }
  }
`
);
var transform = (data) => {
  var _a;
  const playlist = getFragmentData(PlaylistFragment, data.playlist_by_pk);
  const audios = ((_a = getFragmentData(PlaylistAudioFragment, playlist == null ? void 0 : playlist.playlist_audios)) == null ? void 0 : _a.slice().sort((a, b) => a.position - b.position).map(({ audio }) => transformAudioFragment(audio))) || [];
  return {
    audios,
    playlist
  };
};
var useLoadPlaylistDetail = (props) => {
  const { id } = props;
  const { isSignedIn, getAccessToken } = useAuthContext();
  const { data, isLoading, error } = useRequest({
    queryKey: ["listen-playlist-detail", isSignedIn, id],
    getAccessToken: isSignedIn ? getAccessToken : void 0,
    document: playlistDetailQuery,
    variables: {
      id
    }
  });
  const transformed = data ? transform(data) : {
    audios: [],
    playlist: null
  };
  return __spreadProps(__spreadValues({}, transformed), {
    isLoading,
    error
  });
};

export { useLoadPlaylistDetail };
//# sourceMappingURL=chunk-IXZ5SXUJ.mjs.map
//# sourceMappingURL=chunk-IXZ5SXUJ.mjs.map